<template>
  <chart-container :titleChart="titleChart" @onCSVDownload="downloadCSVGraphs()" @zoomEnabled="zoomGraph(true)" @zoomDisabled="zoomGraph(false)" :downloadId="containerId" :specificSiteId="specificSiteId" :zoomGraphValue="zoomGraphValue" :downloadShow="dataSource.categories && Object.keys(dataSource.categories).length > 0 && Object.keys(dataSource.categories[0].category).length > 0">
    <fusioncharts slot="body" class="fusion-bar-chart" style="width: 100%;" :type="type" width="100%" :height="height" dataFormat="json" :dataSource="dataSource" dataEmptyMessage="No Data In" ref="timeActiveStatusPercentage" v-if="dataSource.categories && Object.keys(dataSource.categories).length > 0 && Object.keys(dataSource.categories[0].category).length > 0" />
    <div slot="body" v-else class="align-center p-60">
      <div class="card-text-title no-data" v-if="dataLoaded">No Data In</div>
    </div>
  </chart-container>
</template>
<script>
import _ from "lodash";
import { downloadCSV } from "../../services/visualization/recruitment";
import ChartContainer from "@/components/containers/chart-container";

export default {
  props: {
    vis: { type: Object, default: null },
    titleChart: { type: String, default: "" },
    subtitleChart: { type: String, default: "" },
    containerId: { type: String },
    tooltipCallbacks: Object,
    zoomGraphValue: { type: String, default: "" },
    specificSiteId: { type: Array, default: () => [] },
    dataLoaded: { type: Boolean, default: false }
  },
  data() {
    return {
      newVis: this.vis,
      data: null,
      options: null,
      newContainerId: "",
      downloadId: "",
      todayDate: "",
      tDateShow: true,
      zoomGraphValueChild: "",
      type: "scrollcolumn2d",
      dataSource: {},
      height: "250"
    };
  },
  watch: {
    vis() {
      this.newVis = this.vis;
      this.processData();
    },
    zoomGraphValue: function(newVal) {
      this.zoomGraphValueChild = newVal;
      if (newVal == "") {
        this.height = "250px";
      }
    }
  },
  components: {
    ChartContainer
  },
  methods: {
    downloadCSVGraphs() {
      let theAverage = [];
      if (this.specificSiteId.length > 0) {
        theAverage = [];
      } else {
        theAverage = this.newVis.trendlines[0].line[0].displayvalue;
      }
      this.tDateShow = true;
      const header = ["site_name", "country_name", "quiz_total", "quiz_completed", "quiz_incomplete", "quiz_completion_percentage"];
      const newArr = [];
      this.newVis.data.map(item => {
        item.percentage = Number(item.percentage.replace("%", ""));
      });

      const orderArr = _.orderBy(this.newVis.data, ["percentage"], ["asc"]);
      orderArr.map(row => {
        newArr.push([row.site, row.country, row.total, row.completed, row.incompleted, Number(row.percentage).toFixed(2) + "%"]);
      });
      downloadCSV(this.titleChart, header, newArr, [theAverage], this.specificSiteId);
    },
    zoomGraph(status) {
      if (status) {
        this.zoomGraphValueChild = true;
        this.height = "400";
        this.$emit("zoomEnabled");
      } else {
        this.zoomGraphValueChild = false;
        this.height = "250";
        this.$emit("zoomDisabled");
      }
    },
    processData() {
      if (this.newVis) {
        this.dataSource = this.newVis;
        if (this.specificSiteId.length > 0) {
          this.dataSource.chart.xaxisname = "";
        }
      }
    }
  },
  mounted() {
    this.processData();
    if (this.containerId == "quizCompleteContainer") {
      this.downloadId = "quiz-completion-area";
    } else if (this.containerId == "econsentUploadedContainer") {
      this.downloadId = "econsent-area";
    }
    this.newContainerId = this.containerId;
  }
};
</script>
